/**
 * The controls card: every key, and what it does, on a small card you toggle
 * with H.
 *
 * The same list the click-to-play screen shows, because there is one list
 * (`CONTROLS` in `main.js`) and two places to read it. A key and a few words:
 * what it does, not why. It sits on the right under the minimap, clear of the
 * clock and the objective on the left and of the prompt at the bottom, and it
 * goes away with the rest of the HUD when a panel owns the screen.
 */
export function createControlsCard({ parent, controls }) {
  const root = document.createElement('div');
  root.className = 'controls-card';
  root.hidden = true;
  root.innerHTML = `
    <div class="controls-card-title">CONTROLS <span>[H] hide</span></div>
    <dl>${controls.map(([key, what]) => `<dt>${key}</dt><dd>${what}</dd>`).join('')}</dl>`;
  parent.append(root);

  // The one line that says the card exists, under the map, while it is shut.
  const hint = document.createElement('div');
  hint.className = 'controls-hint';
  hint.textContent = '[Q] what do I do?\n[H] controls';
  parent.append(hint);

  return {
    root,
    get open() {
      return !root.hidden;
    },
    toggle() {
      root.hidden = !root.hidden;
      hint.hidden = !root.hidden;
      return !root.hidden;
    },
    close() {
      root.hidden = true;
      hint.hidden = false;
    },
    /** Swaps the list, for the controller's, when the pad is the device in use. */
    setControls(next) {
      root.querySelector('dl').innerHTML = next.map(([key, what]) => `<dt>${key}</dt><dd>${what}</dd>`).join('');
    },
  };
}
